// extracted by mini-css-extract-plugin
export default {"userfeed_wrapper":"UserFeed_userfeed_wrapper__sN4Tc"};